module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/fLrq3I/tc-custom/9783987445712.jpg?1704424793866",
      "alt": "This image is the cover for the book Die Lebensanschauungen der großen Denker, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Die Lebensanschauungen der großen Denker, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Zur Einführung des Werkes mögen nur einige wenige Worte dienen. Es will keineswegs ein System der Religionsphilosophie sein; für ein solches Unternehmen ist die Lage der Gegenwart viel zu verworren und die Stellung der Religion in ihr viel zu unsicher. Was heute not tut, ist vielmehr, solcher Unsicherheit entgegenzuwirken; wie das nicht geschehen kann ohne eine Verständigung über das Wesen und den Wert der Religion, so treibt es zwingend auch zu einer Beleuchtung des Ganzen des Menschenlebens. In der geistigen Anarchie unserer Zeit läßt sich an keinen festen und zugestandenen Punkt anknüpfen, alle Erörterung tieferer Art hat auf die Grundlagen zurückzugehen und von hier aus neu aufzubauen. So mußten auch wir uns aus einer allgemeinen Erwägung des menschlichen Daseins erst Schritt für Schritt zu der Stelle hinarbeiten, wo das Problem der Religion hervorbricht, um sich dann freilich bald als den Mittelpunkt alles Strebens nach Seele und Sinn unseres Daseins zu erweisen.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rudolf Eucken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rudolf Christoph Eucken (* 5. Januar 1846 in Aurich, Ostfriesland; † 15. September 1926 in Jena) war ein deutscher Philosoph. 1908 erhielt er den Nobelpreis für Literatur.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0